import { DataGridProps, DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import { LoadingDialog } from 'src/components';
import { CustomPagination, NoRowsOverlay } from 'src/components/Layout';
import SearchFirstDataGridOverlay from 'src/components/Layout/SearchFirstDataGridOverlay';
import { dataGridDefaults } from 'src/utils/constant';
import { usePageConfigProviderContext } from '..';

const DataGrid = (props: DataGridProps) => {
  const { list, page, isLoading, shouldClickBeforeInitFetch, isSearchButtonClicked, onPageChange } =
    usePageConfigProviderContext();

  if (isLoading) return <LoadingDialog forceOpen />;

  return (
    <MuiDataGrid
      {...dataGridDefaults}
      rowCount={list.count}
      page={page}
      onPageChange={onPageChange}
      components={{
        NoRowsOverlay:
          shouldClickBeforeInitFetch && !isSearchButtonClicked
            ? SearchFirstDataGridOverlay
            : NoRowsOverlay,
        Footer: CustomPagination,
      }}
      componentsProps={{
        footer: { totalRecords: list.count },
      }}
      {...props}
    />
  );
};
export default DataGrid;
